<script>
import { Logotypes } from '@/api'
import ListMixin from '@/crudBases/list/ListMixin'

export default {
  mixins: [ListMixin],
  data() {
    return {
      editRouteName: 'Edit Logotypes',
      addRoute: { name: 'Add Logotypes' },
      verboseName: 'Logotypy',
      verboseNamePlural: 'Logotypy',
      listFields: [
        { prop: 'id', label: 'id', width: 80 },
        { prop: 'name', label: 'nazwa' }
      ]
    }
  },
  computed: {
    service() {
      return Logotypes
    }
  }
}
</script>
